import {inject, Injectable} from "@angular/core";
import {Router} from "@angular/router";
import {LorenAsset} from "../interfaces/loren-asset.interface";
import {LorenAssetService} from "../services/loren-asset-service/loren-asset.service";
import {BaseEntitiesResolver} from "../../../shared/resolvers/loren-base-entities-resolver/base-entities.resolver";

@Injectable()
export class LorenAllAssetResolver extends BaseEntitiesResolver<LorenAsset> {
    protected service = inject(LorenAssetService);
    protected router = inject(Router);

    resolve() {
        return this.service.getAllAssetsWithPropertiesAndGroups();
    }
}
